import React, { useEffect, useState } from "react";
import {
    Table,
    Tag,
    Card,
    Button,
    Space,
    Form,
  Input,
Select,
    Typography,
    Popconfirm,
    Modal,
    Divider,
    Avatar,
    Row,
    Col,
    Tooltip,
} from "antd";
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    SearchOutlined,
    EyeOutlined,
    UserOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import useMessage from "antd/es/message/useMessage";
import { UserService } from "../../../Services/Manage/UserService";
import { ComplaintService } from "../../../Services/Manage/ComplaintService";
import CreateComplaint from "./CreateComplaint";

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};


const ManageComplaints = () => {
    const perm = getPermission('/complaint-raise');
    const [filteredData, setFilteredData] = useState([]);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [searchText, setSearchText] = useState('');

    const [rawData, setRawData] = useState([]);
const [statusFilter, setStatusFilter] = useState('all');

    const [form] = Form.useForm();
    const [messageApi, messageContxt] = useMessage();

    const [viewVisible, setViewVisible] = useState(false);
    const [viewItem, setViewItem] = useState(null);
    const statusColors = {
        sent: "blue",
        read: "default",
        replied: "green",
    };

    const formatDateTime = (value) =>
        value
            ? new Date(value).toLocaleString("en-GB", {
                timeZone: "Asia/Kolkata",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            })
            : "-";

    const GetAllComplaints = async () => {
        try {
            const user = await UserService.getOmeUser();
            const request = await ComplaintService.getComplaintsByUser(user.uid);
      const mapped = request.data.map((item, index) => ({ ...item, si_no: index + 1 }));
setRawData(mapped);
filterData(searchText, statusFilter, mapped);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        GetAllComplaints();
    }, []);
const filterData = (search, status, source = rawData) => {
    let data = source;
    if (status !== 'all') data = data.filter((item) => item.status === status);
    if (search) data = data.filter((item) =>
        Object.values(item).some((val) => val && typeof val === 'string' && val.toLowerCase().includes(search))
    );
    setFilteredData(data);
};

const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    filterData(value, statusFilter);
};

const handleStatusFilter = (status) => {
    setStatusFilter(status);
    filterData(searchText, status);
};

    const handleView = (record) => {
        setViewItem(record);
        setViewVisible(true);
    };

    const columns = [
        {
            title: 'S. No.',
            dataIndex: 'si_no',
            key: 'si_no',
            align: 'center'
        },
        {
            title: 'Subject',
            dataIndex: 'title',
            key: 'title',
        },
        // {
        //     title: 'Description',
        //     dataIndex: 'description',
        //     key: 'description',
        //     render: (html) => {
        //         if (!html) return "-";
        //         const text = html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
        //         return (
        //             <div
        //                 style={{ maxWidth: 250, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        //                 title={text}
        //             >
        //                 {text || "-"}
        //             </div>
        //         );
        //     },
        // },
        // {
        //     title: "Reply",
        //     dataIndex: "reply",
        //     key: "reply",
        //     align: "center",
        //     render: (reply) =>
        //         reply ? (
        //             <Tag color="green">Replied</Tag>
        //         ) : (
        //             <Tag color="orange">Pending</Tag>
        //         ),
        // },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <Tag color={statusColors[status] || "default"}>
                    {status ? status.toUpperCase() : "-"}
                </Tag>
            ),
        },
        {
            title: 'Added On',
            dataIndex: 'added_on',
            key: 'added_on',
            render: (date) => formatDateTime(date),
        },
        {
            title: 'Updated On',
            dataIndex: 'updated_on',
            key: 'updated_on',
            render: (date) => formatDateTime(date),
        },
        {
            title: 'Actions',
            key: 'actions',
            fixed: 'right',
           render: (text, record) => (
                <Space size="middle">
                    <Button
                        size='large'
                        icon={<EyeOutlined />}
                        onClick={() => handleView(record)}
                    />
                    <Tooltip title={!perm.edit ? "You don't have permission to edit" : ""}>
                        <Button
                            size='large'
                            icon={<EditOutlined />}
                            onClick={() => handleEdit(record)}
                            disabled={!perm.edit}
                        />
                    </Tooltip>
                    <Popconfirm
                        title="Delete complaint"
                        description="Are you sure you want to delete this complaint?"
                        okText="Yes"
                        cancelText="No"
                        okButtonProps={{ danger: true }}
                        onConfirm={() => handleDelete(record)}
                        disabled={!perm.delete}
                    >
                        <Tooltip title={!perm.delete ? "You don't have permission to delete" : ""}>
                            <Button
                                size='large'
                                danger
                                icon={<DeleteOutlined />}
                                disabled={!perm.delete}
                            />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const showDrawer = () => {
        setEditingItem(null);
        form.resetFields();
        setDrawerVisible(true);
    };
const handleEdit = async (record) => {
    setEditingItem(record);
    window.__complaintPendingImages = [];
    form.setFieldsValue({
        title: record.title,
        description: record.description || "",
    });
    setDrawerVisible(true);
};

    const handleDelete = async (record) => {
        try {
            const request = await ComplaintService.deleteComplaint(record.id);
            if (request.status) {
                messageApi.success(request.message);
                GetAllComplaints();
            } else {
                messageApi.error(request.message);
            }
        } catch (error) {
            console.log(error);
            messageApi.warning(error);
        }
    };

    const handleDrawerClose = () => {
        setDrawerVisible(false);
        form.resetFields();
    };

    const onFinish = async (values) => {
        const user = await UserService.getOmeUser();
        const newItem = {
            ...values,
            raised_by: user.uid,
            status: editingItem ? editingItem.status : "sent",
        };

        if (editingItem) {
            const request = await ComplaintService.updateComplaint(newItem, editingItem.id);
            if (request.status) {
                messageApi.success(request.message);
                GetAllComplaints();
            } else {
                messageApi.error(request.message);
            }
        } else {
            const request = await ComplaintService.createComplaint(newItem);
            if (request.status) {
                messageApi.success(request.message);
                GetAllComplaints();
            } else {
                messageApi.error(request.message);
            }
        }

        setDrawerVisible(false);
        form.resetFields();
    };

    return (
        <div>
            <Card
                title={
                    <Typography.Title level={4}>Complaint Raise</Typography.Title>
                }
                extra={
                    <Space>
<Select
    size="large"
    value={statusFilter}
    onChange={handleStatusFilter}
    style={{ width: 140 }}
    showSearch
    allowClear
    onClear={() => handleStatusFilter('all')}
    options={[
        { value: 'all', label: 'All Status' },
        { value: 'sent', label: 'Sent' },
        { value: 'read', label: 'Read' },
        { value: 'replied', label: 'Replied' },
    ]}
/>
<Input
    size='large'
    placeholder="Search..."
                            prefix={<SearchOutlined />}
                            value={searchText}
                            onChange={handleSearch}
                            style={{ width: 300 }}
                            allowClear
                        />
                       <Tooltip title={!perm.add ? "You don't have permission to create" : ""}>
                            <Button
                                type="primary"
                                size="large"
                                icon={<PlusOutlined />}
                                onClick={showDrawer}
                                disabled={!perm.add}
                            >
                                Raise Complaint
                            </Button>
                        </Tooltip>
                    </Space>
                }
            >
                <Table
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{ pageSize: 10 }}
                    scroll={{ x: true }}
                />
            </Card>
            {messageContxt}

            <CreateComplaint
                visible={drawerVisible}
                onClose={handleDrawerClose}
                onFinish={onFinish}
                form={form}
                editingItem={editingItem}
            />

            {/* Email-style View Modal (read-only for the user) */}
            <Modal
                title={null}
                open={viewVisible}
                onCancel={() => setViewVisible(false)}
                footer={[
                    <Button key="close" onClick={() => setViewVisible(false)}>
                        Close
                    </Button>,
                ]}
                width={720}
                styles={{ body: { paddingTop: 8 } }}
            >
                {viewItem && (
                    <div>
                        {/* Subject */}
                        <h2 style={{ margin: "8px 0 16px", fontWeight: 600 }}>
                            {viewItem.title || "Complaint"}
                        </h2>

                        {/* Your complaint */}
                        <Row align="middle" justify="space-between" style={{ marginBottom: 8 }}>
                            <Col>
                                <Space>
                                    <Avatar icon={<UserOutlined />} style={{ backgroundColor: "#1677ff" }} />
                                    <div>
                                        <div style={{ fontWeight: 500 }}>You</div>
                                        <div style={{ fontSize: 12, color: "#999" }}>
                                            {formatDateTime(viewItem.added_on)}
                                        </div>
                                    </div>
                                </Space>
                            </Col>
                            <Col>
                                <Tag color={statusColors[viewItem.status] || "default"}>
                                    {viewItem.status ? viewItem.status.toUpperCase() : "-"}
                                </Tag>
                            </Col>
                        </Row>

                        <div
                            className="ql-editor"
                            style={{ padding: 0, fontSize: 15, lineHeight: 1.6 }}
                            dangerouslySetInnerHTML={{ __html: viewItem.description || "-" }}
                        />

                        {/* Admin's reply */}
                        {viewItem.reply ? (
                            <>
                                <Divider />
                                <div
                                    style={{
                                        borderLeft: "3px solid #52c41a",
                                        background: "#f6ffed",
                                        borderRadius: 4,
                                        padding: "12px 16px",
                                    }}
                                >
                                    <Space style={{ marginBottom: 6 }}>
                                        <Avatar size="small" icon={<UserOutlined />} style={{ backgroundColor: "#52c41a" }} />
                                        <span style={{ fontWeight: 500 }}>Reply</span>
                                        <span style={{ fontSize: 12, color: "#999" }}>
                                            {formatDateTime(viewItem.replied_on)}
                                        </span>
                                    </Space>
                                    <div
                                        className="ql-editor"
                                        style={{ padding: 0, fontSize: 14 }}
                                        dangerouslySetInnerHTML={{ __html: viewItem.reply }}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <Divider />
                                <div style={{ color: "#999", fontStyle: "italic" }}>
                                    No reply yet. Awaiting response.
                                </div>
                            </>
                        )}
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default ManageComplaints;